import each from '../each';

export default {
	...each,
	/**
	 * Get and setter for localstorage
	 */
	storage: {
		get: (key) => {
			if (!window) return;

			let obj = window.localStorage.getItem(key);
			if (!obj) return null;

			return JSON.parse(obj);
		},
		set: ({ key, value }) => {
			if (!window) return;

			if (!key || !value) return null;

			let obj = window.localStorage.getItem(key);

			if (!obj) obj = {};
			if (obj && typeof obj !== 'object') obj = JSON.parse(obj);

			obj[key] = value;

			window.localStorage.setItem(key, JSON.stringify(value));

			return obj;
		},
	},

	/**
	 * Gets browser agent type
	 * @return { object } { device, browser }
	 * */
	getNavigatorAgent: function () {
		if (!window) return;
		const userAgent = navigator.userAgent;
		let device = null;
		let browser = null;

		if (userAgent.match(/Android/i)) device = 'android';
		if (userAgent.match(/BlackBerry/i)) device = 'blackberry';
		if (userAgent.match(/iPhone|iPad|iPod/i)) device = 'ios';
		if (userAgent.match(/Opera Mini/i)) device = 'opera-mini';
		if (userAgent.match(/IEMobile/i)) device = 'ie-mobile';
		if (userAgent.match(/IEMobile/i)) device = 'ie-mobile';

		if (userAgent.indexOf('chrome') > -1 || userAgent.indexOf('Chrome') > -1) {
			browser = 'chrome';
			return { browser, device };
		}
		if (userAgent.indexOf('firefox') > -1 || userAgent.indexOf('Firefox') > -1) {
			browser = 'firefox';
			return { browser, device };
		}
		if (userAgent.indexOf('safari') > -1 || userAgent.indexOf('Safari') > -1) {
			browser = 'safari';
			return { browser, device };
		}
		if (userAgent.indexOf('opr') > -1 || userAgent.indexOf('Opr') > -1) {
			browser = 'opera';
			return { browser, device };
		}
		if (
			userAgent.indexOf('edg') > -1 ||
			userAgent.indexOf('edge') > -1 ||
			userAgent.indexOf('Edg') > -1 ||
			userAgent.indexOf('Edge') > -1
		) {
			browser = 'edge';
			return { browser, device };
		}
		if (userAgent.indexOf('trident') > -1 || userAgent.indexOf('Trident') > -1) {
			browser = 'internet-explorer';
			return { browser, device };
		}

		return { device, browser };
	},
	/**
	 * Gets CSS variables for usage
	 * @param { string } variable name
	 * */
	getCSSVariable: function (variable) {
		if (!window) return;

		return getComputedStyle(document.body).getPropertyValue(variable);
	},
	/**
	 * Creates intersection observe to detect when element comes into view
	 * @params { object } el - dom element to monitor
	 * @params { func } callback - returns event when dom element comes in and out of status
	 * */
	intersectionObserver: function (el, callback, options = {}) {
		if (!window) return;

		if (!el || !callback) return;
		const observer = new IntersectionObserver(callback, options);
		observer.observe(el);
	},
	/**
	 * Listens for change on element class names
	 * @param { object } el - target dom element
	 * @param { string } classname - class to listen for toggle on and off
	 * @param { func } on - callback for active class
	 * @param { func } off - callback for inactive class
	 * */
	classObserver: function (el, classname, on, off) {
		if (!window) return;
		if (!el || !classname) return;

		const observer = new MutationObserver(function (event) {
			if (el.className.indexOf(classname) > -1 && on) on();
			if (el.className.indexOf(classname) === -1 && off) off();
		});

		observer.observe(el, {
			attributes: true,
			attributeFilter: ['class'],
			childList: false,
			characterData: false,
		});
	},
	/*
	 * Gets url query paramters by key
	 * @param { string } key - name of query parameter
	 * @return { string|object|null } query parameter value if exists
	 * */
	queryParams: function (key) {
		if (!window) return;

		if (!key) {
			const params = {};
			for (const [key, value] of new URLSearchParams(window.location.search).entries()) {
				params[key] = value;
			}

			return params;
		}

		if (key) {
			const params = new Proxy(new URLSearchParams(window.location.search), {
				get: (searchParams, prop) => searchParams.get(prop),
			});

			if (params[key]) return params[key];
		}
		return null;
	},
	/**
	 * Listens for http requests
	 * @return {Number|Null} Number of request
	 */
	mockFetch: function () {
		if (!window) return;
		if (!window.fetch) return;

		const mock = window.fetch;
		window.fetch = async function () {
			const response = await mock.apply(this, arguments);

			if (response && response.status === 200) {
				return response;
			}

			return null;
		};
	},
};
